import { Inject, Injectable } from "@angular/core";
import { BaseService } from "./base-service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { AddLoginHistory, EventHistoryRecords, UpdateEventHistoryTableParam } from "../_models/EventDto";
import { Observable } from "rxjs";
import { HttpParamsConstants } from "../constants/HttpParamsConstants";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class EventHistoryService extends BaseService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "EventHistory/";
  private static readonly ADD_LOGIN_DATE: string = "addlogindate";
  private static readonly DISPLAY_EVENT_HISTORIES: string = "displayeventhistories";
  private static readonly GET_CURRENT_PAGE_NUMBER: string = "getcurrentpagenumber";
  private static readonly UPDATE_EVENT_HISTORIES_TABLE : string = "updateeventhistories";
  private static readonly EVENT_HISTORIES_LENGTH: string = "eventhistorieslength";

  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    super(http);
  }

  public saveLoginEvent$(loginEvent: AddLoginHistory): Observable<boolean> {    
    return this.http.post<boolean>(
      this.baseUrl +
      EventHistoryService.path + 
      EventHistoryService.ADD_LOGIN_DATE,
      loginEvent
    );
  }

  public getEventHistoriesRecords$(
    userId: number,
    pageIndex: number,
    isInitialLoad: boolean
  ): Observable<EventHistoryRecords[]> {
    let params = new HttpParams().set(AppConstants.USER_ID, String(userId));
        params = params.set(HttpParamsConstants.PAGE_NUMBER, String(+pageIndex+1));
    if (isInitialLoad)
        params = params.set(HttpParamsConstants.INITIAL_LOAD, String(isInitialLoad));

    return this.http.get<EventHistoryRecords[]>(
      this.baseUrl +
      EventHistoryService.path + 
      EventHistoryService.DISPLAY_EVENT_HISTORIES,
      { params }
    );
  }

  public getCurrentPageNumber$(pageNumber: number): Observable<number> {
    let params = new HttpParams().set(AppConstants.PAGE_NUMBER, String(pageNumber));

    return this.http.get<number>(
      this.baseUrl +
      EventHistoryService.path + 
      EventHistoryService.GET_CURRENT_PAGE_NUMBER,
      { params }
    );
  }

  public updateEventHistoriesTable$(
    update: UpdateEventHistoryTableParam, 
    userId: number
  ): Observable<boolean> {
    let params = new HttpParams().set(AppConstants.USER_ID, String(userId));

    return this.http.put<boolean>(
      this.baseUrl +
      EventHistoryService.path + 
      EventHistoryService.UPDATE_EVENT_HISTORIES_TABLE,
      update,
      { params }
    );
  }

  public getEvenHistoryRecordLength$(): Observable<number> {
    return this.http.get<number>(
      this.baseUrl +
      EventHistoryService.path + 
      EventHistoryService.EVENT_HISTORIES_LENGTH
    );
  }
}